import React, { useState } from 'react'
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import { compareAsc, format } from 'date-fns'
import moment from "moment";
import { json } from 'react-router-dom'

function UserLoginExcelReportComp() {
    const controller = new AbortController(); // Add cancellation if needed
    const signal = controller.signal;
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let token = JSON.parse(localStorage.getItem('key'));

    const [loader, setLoader] = useState(false)
    const [report, setReport] = useState('')
    const handleReportType = (type) => {
        setReport(type)
    }
    const loggedInUserReport = () => {
        setLoader(true)
        getLoggedInUser()
    }


    const getLoggedInUser = async () => {
        try {
            const current_date = moment().format("YYYY-MM-DD");
            const response = await fetch(SERVER_URL + `api/reports/loggedinusers?currentdate=${current_date}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${token.value}`
                },
                signal
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            if (result.results.length > 0) {

                // Initialize Excel workbook and sheet
                const workbook = await XlsxPopulate.fromBlankAsync();
                const sheet = workbook.sheet(0);

                // Define header row
                const headerTitle = `Today Users Logged In (${result.results.length})`;

                // Merge and Style Header
                sheet.range("A1:F1").merged(true);
                sheet.cell("A1").value(headerTitle).style({
                    bold: true,
                    fontSize: 16,
                    fill: "aed9ff", // Light Blue Background
                    horizontalAlignment: "center",
                    verticalAlignment: "center",
                    border: true
                });

                // Column Headers
                const headers = ["User Name", "User Code", "Dept Name", "DATE", "DAY", "Status"];
                headers.forEach((text, index) => {
                    sheet.cell(2, index + 1).value(text).style({
                        bold: true,
                        fontSize: 12,
                        fill: "d0e1f9", // Light Gray Background
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                        border: true
                    });
                });

                // Populate data rows
                result.results.forEach((item, rowIndex) => {
                    const row = [
                        item.name,
                        item.user_code,
                        item.deptName,
                        moment(item.att_date).format("DD MMM, YYYY"),
                        moment(item.att_date).format("ddd"),
                        "Logged-In"
                    ];
                    row.forEach((cell, colIndex) => {
                        sheet.cell(rowIndex + 3, colIndex + 1).value(cell).style({
                            border: true,
                            horizontalAlignment: "center"
                        });
                    });
                });

                // Adjust Column Widths
                [25, 20, 20, 18, 15, 20].forEach((width, i) => {
                    sheet.column(i + 1).width(width);
                });

                // Generate and trigger download
                const blob = await workbook.outputAsync();
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `Users_logged_in.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.error('Error fetching data or generating the report:', err);
        } finally {
            setLoader(false); // Stop loading indicator
        }
    };


    const notloggedInUserReport = async () => {
        setLoader(true)
        try {
            const current_date = moment().format("YYYY-MM-DD");
            const response = await fetch(SERVER_URL + `api/reports/notloggedinusers?currentdate=${current_date}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${token.value}`
                },
                signal
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            if (result.results.length > 0) {

                // Initialize Excel workbook and sheet
                const workbook = await XlsxPopulate.fromBlankAsync();
                const sheet = workbook.sheet(0);

                // Define header row
                const headerTitle = `Today Users Not Logged In (${result.results.length})`;

                // Merging and Styling Header
                sheet.range("A1:F1").merged(true);
                sheet.cell("A1").value(headerTitle).style({
                    bold: true,
                    fontSize: 16,
                    fill: "aed9ff", // Light Blue Background
                    horizontalAlignment: "center",
                    verticalAlignment: "center",
                    border: true
                });

                // Column Headers
                const headers = ["User Name", "User Code", "Dept Name", "DATE", "DAY", "Status"];
                headers.forEach((text, index) => {
                    sheet.cell(2, index + 1).value(text).style({
                        bold: true,
                        fontSize: 12,
                        fill: "d0e1f9", // Light Gray Background
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                        border: true
                    });
                });

                // Populate data rows
                result.results.forEach((item, rowIndex) => {
                    const row = [
                        item.name,
                        item.user_code,
                        item.deptName,
                        moment().format("DD MMM, YYYY"),
                        moment().format("ddd"),
                        "Not Logged-In"
                    ];
                    row.forEach((cell, colIndex) => {
                        sheet.cell(rowIndex + 3, colIndex + 1).value(cell).style({
                            border: true,
                            horizontalAlignment: "center"
                        });
                    });
                });

                // Adjust Column Widths
                [25, 20, 20, 18, 15, 20].forEach((width, i) => {
                    sheet.column(i + 1).width(width);
                });

                // Generate and trigger download
                const blob = await workbook.outputAsync();
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `Users_not_logged_in.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.error('Error fetching data or generating the report:', err);
        } finally {
            setLoader(false); // Stop loading indicator
        }
    };


    return (
        <>
            <div className='row'>
                <div className='col-md-3'>
                    <div className='form-blk mb25'>
                        <div className='form-label'>Type of Report</div>
                        <div className='form-input'>
                            <select onChange={e => handleReportType(e.target.value)} value={report} className="form-select">
                                <option value=''>Select Type of Report</option>
                                <option value='1'>User Logged-In</option>
                                <option value='2'>User Not Logged-In</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className={`col-md-3 mb25 ${report == 1 ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk'>
                        <label className="h22"></label>
                        <div className='form-input'>
                            <button className="btn_5"
                                onClick={loggedInUserReport}
                                disabled={loader}
                            >{loader == true && <i className='fa fa-circle-o-notch fa-spin mr05'></i>}  Download</button>
                        </div>
                    </div>
                </div>
                <div className={`col-md-3 mb25 ${report == 2 ? 'd-inline' : 'd-none'}`}>
                    <div className='form-blk'>
                        <label className="h22"></label>
                        <div className='form-input'>
                            <button className="btn_5"
                                onClick={notloggedInUserReport}
                                disabled={loader}
                            >{loader == true && <i className='fa fa-circle-o-notch fa-spin mr05'></i>} Download</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserLoginExcelReportComp
